import React from 'react';
import Sidebar from './Sidebar';
import houseThumb from '../assets/ngoinha1.png';
import userAvatar from '../assets/hinhnguoi.png';
import aromaImg from '../assets/aroma.png';
import humiImg from '../assets/humi.png';
import speakerImg from '../assets/speaker.png';
import lampImg from '../assets/smartlamp.png';
import bedroomImg from '../assets/bedroom.png';
import livingImg from '../assets/living.png';
import kitchenImg from '../assets/kitchen.png';
import bathroomImg from '../assets/bathroom.png';

const ConfirmSpace = ({ isVisible, onBack, onContinue, onLogout, connectedDevices, onDeleteDevice, onDeleteMember }) => {
  if (!isVisible) return null;

  // Hàm lấy hình ảnh phòng
  const getRoomImage = (roomName) => {
    const roomLower = roomName.toLowerCase();
    if (roomLower.includes('bedroom')) return bedroomImg;
    if (roomLower.includes('living')) return livingImg;
    if (roomLower.includes('kitchen')) return kitchenImg;
    if (roomLower.includes('bathroom')) return bathroomImg;
    return null;
  };

  // Dữ liệu giả lập cho Rooms (Giống hình mẫu)
  const rooms = [
    { id: 1, name: 'Living Room', size: '20 m²', color: '#597e8d' }, // Màu xanh rêu đậm
    { id: 2, name: 'Kitchen', size: '12 m²', color: '#fca5a5' }, // Màu hồng nhạt
    { id: 3, name: 'Bedroom', size: '16 m²', color: '#d1d5db' }, // Màu xám
    { id: 4, name: 'Bathroom', size: '6 m²', color: '#fcd34d' }, // Màu vàng
  ];

  // Dữ liệu giả lập cho Members (Giống hình mẫu) - Sử dụng hình từ assets
  const members = [
    { id: 1, name: 'Albert Flores', email: 'albert.flores@gmail.com', avatar: userAvatar },
    { id: 2, name: 'Annette Black', email: 'annette.black@gmail.com', avatar: userAvatar },
  ];

  // Dữ liệu thiết bị (Kết hợp danh sách đã kết nối từ App hoặc Mock nếu chưa có)
  // Để giao diện đẹp giống hình, tôi sẽ hardcode danh sách này hiển thị 3 thiết bị tiêu biểu
  const displayDevices = [
      { id: 1, name: 'Smart Lamp', location: 'Living Room', type: 'Lamp' },
      { id: 2, name: 'Speaker', location: 'Living Room', type: 'Speaker' },
      { id: 3, name: 'Humidifier', location: 'Living Room', type: 'Humidifier' }
  ];

  // Helper lấy hình ảnh thiết bị
  const getDeviceImage = (type) => {
    switch(type) {
        case 'Lamp': return lampImg;
        case 'Speaker': return speakerImg;
        case 'Humidifier': return humiImg;
        default: return null;
    }
  };

  // Helper render icon nhỏ (fallback)
  const renderDeviceIcon = (type) => {
    switch(type) {
        case 'Lamp': return '💡';
        case 'Speaker': return '🔊';
        case 'Humidifier': return '💧';
        default: return '🔌';
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar activeId="spaces" onLogout={onLogout} />

      <div className="main-content setup-layout">
        
        {/* --- HEADER --- */}
        <div className="setup-header">
          <button className="back-btn" onClick={onBack}>
             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
          </button>
          
          <div className="header-titles">
            <h2>Create a new space</h2>
            <p>Confirm your choices</p>
          </div>

          <div className="step-indicator">Step <strong>7 | 7</strong></div>
        </div>

        {/* --- BODY --- */}
        <div className="setup-body column-mode confirm-page">
          
          {/* SUMMARY CARD (Reused) */}
          <div className="summary-card">
            <div className="summary-left">
              <img src={houseThumb} alt="House" className="summary-thumb" />
              <div className="summary-info">
                <h3 className="house-title">My Home <span className="edit-icon">✎</span></h3>
                <p className="house-address">11-5 Raddington Rd, London, UK</p>
              </div>
            </div>
            <div className="summary-stats">
               {/* Highlight các chấm màu giống hình */}
              <div className="stat-pill"><span className="dot green"></span> 4 Rooms</div>
              <div className="stat-pill"><span className="dot purple"></span> 3 Devices</div>
              <div className="stat-pill"><span className="dot yellow"></span> 2 Members</div>
            </div>
          </div>

          {/* --- CONTENT GRID --- */}
          <div className="confirm-grid-row">
            
            {/* COLUMN 1: ROOMS */}
            <div className="content-card">
              <div className="card-header">
                <h3>Your Rooms <span className="count-badge">3</span></h3>
              </div>
              <div className="list-container">
                {rooms.map(room => (
                  <div key={room.id} className="list-item">
                    <div className="item-icon-box" style={{backgroundColor: room.color + '33'}}> {/* Màu nền nhạt */}
                       {getRoomImage(room.name) ? (
                         <img 
                           src={getRoomImage(room.name)} 
                           alt={room.name}
                           style={{
                             width: '100%',
                             height: '100%',
                             objectFit: 'cover',
                             borderRadius: '8px'
                           }}
                         />
                       ) : (
                         <span style={{color: room.color}}>🏠</span>
                       )}
                    </div>
                    <div className="item-details">
                      <h4>{room.name}</h4>
                      <p>{room.size}</p>
                    </div>
                    <div className="item-action">
                      <span className="dots">•••</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* COLUMN 2: DEVICES */}
            <div className="content-card">
              <div className="card-header">
                <h3>Your Devices <span className="count-badge">3</span></h3>
              </div>
              <div className="list-container">
                {displayDevices.map(device => (
                  <div key={device.id} className="list-item">
                    <div className="item-icon-box blue-bg">
                       {getDeviceImage(device.type) ? (
                         <img src={getDeviceImage(device.type)} alt={device.name} style={{width: '100%', height: '100%', objectFit: 'contain', padding: '8px'}} />
                       ) : (
                         <span>{renderDeviceIcon(device.type)}</span>
                       )}
                    </div>
                    <div className="item-details">
                      <h4>{device.name}</h4>
                      <p>{device.location}</p>
                    </div>
                    <button 
                      className="item-action trash-btn"
                      onClick={() => onDeleteDevice && onDeleteDevice(device.id, device.name)}
                    >
                       <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>

          </div>

          {/* ROW 2: MEMBERS (Full Width) */}
          <div className="content-card full-width">
              <div className="card-header">
                <h3>Your Members <span className="count-badge">2</span></h3>
              </div>
              <div className="list-container row-layout">
                 {members.map(member => (
                   <div key={member.id} className="list-item member-item">
                      <img src={member.avatar} alt={member.name} className="member-avatar" />
                      <div className="item-details">
                        <h4>{member.name}</h4>
                        <p>{member.email}</p>
                      </div>
                      <button 
                        className="item-action trash-btn"
                        onClick={() => onDeleteMember && onDeleteMember(member.id, member.name)}
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                      </button>
                   </div>
                 ))}
              </div>
          </div>

        </div>

        {/* --- FOOTER --- */}
        <div className="setup-footer">
          <div className="footer-content" style={{justifyContent: 'space-between'}}>
            <span className="footer-hint">Check all the information and start with your new space.</span>
            <button className="primary-btn continue-btn" onClick={onContinue}>
                Done
            </button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ConfirmSpace;